import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/thanks")({
  head: () => ({
    meta: [
      { title: "Thank you — RESTORE Hair" },
      {
        name: "description",
        content:
          "Thanks for reaching out to RESTORE Hair. A specialist will be in touch shortly to schedule your consultation.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ThanksPage,
});

function ThanksPage() {
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-4 py-20 text-center">
      <h1 className="text-4xl font-extrabold text-foreground md:text-5xl">
        Thanks — we'll be in touch.
      </h1>
      <p className="mt-4 text-base leading-relaxed text-muted-foreground md:text-lg">
        A RESTORE Hair specialist will reach out shortly to schedule your free consultation.
        In the meantime, learn more about our doctors and process.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-block bg-primary px-6 py-3 text-sm font-bold tracking-wider text-primary-foreground transition hover:bg-primary/90"
        >
          Back to home
        </Link>
      </div>
    </main>
  );
}